import { useContext } from 'react';
import { RoutePrefixContext } from '../context/RoutePrefixContext';
import { parseHTML as parseHTMLUtil } from '../utils/htmlParser';

export function useParseHTML(htmlString) {
  const routePrefix = useContext(RoutePrefixContext) || "";
  return parseHTMLUtil(htmlString, routePrefix);
}
